import { useEffect } from 'react';
import { Button, Group, Text } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { Brand } from '../ui/Brand';

/** New versions never auto-reload (you might be mid-speech); you choose when. */
export const UpdatePrompt = () => {
  const { needRefresh: [needRefresh], offlineReady: [offlineReady], updateServiceWorker } = useRegisterSW();

  useEffect(() => {
    if (offlineReady) notifications.show({ id: 'offline-ready', title: 'Ready to work offline', message: <><Brand /> is fully cached on this device.</>, color: 'green' });
  }, [offlineReady]);

  useEffect(() => {
    if (!needRefresh) return;
    notifications.show({
      id: 'update',
      autoClose: false,
      title: 'Update ready',
      message: (
        <Group justify="space-between" mt={4}>
          <Text size="sm">Apply it between rounds.</Text>
          <Button size="xs" variant="filled" onClick={() => void updateServiceWorker(true)}>Reload now</Button>
        </Group>
      ),
    });
  }, [needRefresh, updateServiceWorker]);

  return null;
};
